import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e63c50d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "CookiesRow W-75",
  style: {"margin-top":"4em","font-size":"1.1em"}
}
const _hoisted_2 = { class: "SettingsName" }
const _hoisted_3 = { class: "CookiesRow" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"width":"20%"} }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_6 = { class: "SettingsName" }
const _hoisted_7 = { class: "CookiesRow" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"width":"20%"} }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_10 = { class: "SettingsName" }
const _hoisted_11 = { class: "CookiesRow" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"width":"20%"} }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_14 = { class: "SettingsName" }
const _hoisted_15 = { class: "CookiesRow" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"width":"20%"} }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_18 = { class: "SettingsName" }
const _hoisted_19 = { class: "CookiesRow" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"width":"20%"} }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookiesDescriptionBox = _resolveComponent("CookiesDescriptionBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.LanguageSelector('Company Name', 'الاسم')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_CookiesDescriptionBox, {
        style: {"width":"20em","max-width":"50vw"},
        LimitLines: 2,
        CustomStyle: 'max-height: 2.5em; min-height: 2.5em; overflow:hidden; resize: none;',
        Res: 'ComapnySettings_Name',
        onChanged: _cache[0] || (_cache[0] = ($event: any) => (_ctx.SaveConfig('Name', _ctx.MEMRead('ComapnySettings_Name'))))
      })
    ]),
    _hoisted_4,
    _hoisted_5,
    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.Translate('Whatsapp Contact')), 1),
    _createElementVNode("div", _hoisted_7, [
      _withDirectives(_createElementVNode("input", {
        onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.SaveConfig('WhatsappContact', _ctx.$store.state.CookiesConfig.WhatsappContact))),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.$store.state.CookiesConfig.WhatsappContact) = $event)),
        class: "CookiesInput color2",
        type: "text",
        placeholder: "07xxxxxxxx"
      }, null, 544), [
        [_vModelText, _ctx.$store.state.CookiesConfig.WhatsappContact]
      ])
    ]),
    _hoisted_8,
    _hoisted_9,
    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.LanguageSelector('Logo', 'الشعار')), 1),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("label", {
        class: "LogoImageUpload Pointer Shadow1",
        style: _normalizeStyle('background-image: ' + 'url(' + _ctx.DefaultImageHandler(_ctx.$store.state.CookiesConfig.Logo, 'https://cookiesbis.com/assets/Logo.svg') + ')')
      }, [
        _createElementVNode("input", {
          onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.LogoChanged && _ctx.LogoChanged(...args))),
          name: "LogoImageUpload",
          class: "D-None",
          type: "file",
          accept: "image/*"
        }, null, 32)
      ], 4)
    ]),
    _hoisted_12,
    _hoisted_13,
    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.LanguageSelector('Hero Image', 'الصورة الدعائية')), 1),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("label", {
        class: "LogoImageUpload Pointer Shadow1",
        style: _normalizeStyle([{"width":"20em","background-size":"cover"}, 'background-image: ' + 'url(' + _ctx.DefaultImageHandler(_ctx.$store.state.CookiesConfig.HeroImage, _ctx.DefaultImage) + ')'])
      }, [
        _createElementVNode("input", {
          onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.HeroImageChanged && _ctx.HeroImageChanged(...args))),
          name: "HeroImageUpload",
          class: "D-None",
          type: "file",
          accept: "image/png, image/gif, image/jpeg"
        }, null, 32)
      ], 4)
    ]),
    _hoisted_16,
    _hoisted_17,
    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.LanguageSelector('FAV ICON', 'رمز الويبسايت')), 1),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("label", {
        class: "LogoImageUpload Pointer Shadow1",
        style: _normalizeStyle([{"width":"3em","height":"3em"}, 'background-image: ' + 'url(' + _ctx.DefaultImageHandler(_ctx.$store.state.CookiesConfig.FavIco, _ctx.DefaultImage) + ')'])
      }, [
        _createElementVNode("input", {
          onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.FavIcoChanged && _ctx.FavIcoChanged(...args))),
          name: "FavIcoImageUpload",
          class: "D-None",
          type: "file",
          accept: ".ico"
        }, null, 32)
      ], 4)
    ]),
    _hoisted_20
  ]))
}